"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _context = require("../../context");

var _layout = require("../../layout");

var _ = require("../");

var _dateTimeSegments = require("../date-time-segments");

var _core = require("@emotion/core");

var PopupSegmentRow = (0, _context.styledWithTheme)(_layout.Row)(function (_ref) {
  var selectors = _ref.theme.selectors;
  return "\n  font-size: ".concat(selectors.fontSize('T300'), ";\n  font-family: ").concat(selectors.fontFamily('primary'), ";\n");
});

var DateTimeInputPopupContent = function DateTimeInputPopupContent(_ref2) {
  var ariaLabels = _ref2.ariaLabels,
      datePickerProps = _ref2.datePickerProps,
      disabled = _ref2.disabled,
      handleChange = _ref2.handleChange,
      locale = _ref2.locale,
      segmentValues = _ref2.segmentValues,
      showSeconds = _ref2.showSeconds,
      showMilliseconds = _ref2.showMilliseconds;

  var handleDatePickerSelection = function handleDatePickerSelection(val) {
    var _val$split$map = val.split('-').map(function (segment) {
      return parseInt(segment);
    }),
        _val$split$map2 = (0, _slicedToArray2.default)(_val$split$map, 3),
        year = _val$split$map2[0],
        month = _val$split$map2[1],
        day = _val$split$map2[2];

    handleChange({
      year: year,
      month: month,
      day: day
    });
  };

  return (0, _core.jsx)(_layout.Col, {
    gridGap: "S300"
  }, (0, _core.jsx)(_.DatePicker, (0, _extends2.default)({
    value: "".concat(segmentValues.year, "-").concat(segmentValues.month, "-").concat(segmentValues.day),
    onChange: handleDatePickerSelection,
    locale: locale
  }, datePickerProps)), (0, _core.jsx)(_layout.View, {
    padding: [0, 'S300']
  }, (0, _core.jsx)(_layout.Hr, null)), (0, _core.jsx)(PopupSegmentRow, {
    justifyContent: "center",
    alignItems: "center"
  }, (0, _core.jsx)(_dateTimeSegments.DateTimeSegments, {
    segmentValues: segmentValues,
    onChange: handleChange,
    disabled: disabled,
    showDate: false,
    showTime: true,
    showSeconds: showSeconds,
    showMilliseconds: showMilliseconds,
    showSpinButtons: true,
    ariaLabels: ariaLabels
  })));
};

var _default = DateTimeInputPopupContent;
exports.default = _default;